export const LANDING_PLAN_COLORS: Record<string, string> = {
	professional: '#72DE2F',
	premium: '#F93030',
	basic: '#5A6ACF',
};

export const LANDING_PLAN_FALLBACK_COLORS = Object.values(LANDING_PLAN_COLORS);

export const TESTIMONIALS_LINE_DATA = [
	{ day: '01', atual: 0, anterior: 5 },
	{ day: '02', atual: 10, anterior: 8 },
	{ day: '03', atual: 50, anterior: 35 },
	{ day: '04', atual: 20, anterior: 28 },
	{ day: '05', atual: 0, anterior: 12 },
	{ day: '06', atual: 40, anterior: 30 },
];
